import React, { useReducer, useContext, useEffect, useState } from "react";
import { Collapse } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { getSidebarMenusApi } from "../../../services/apis/SidebarMenuApi";

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
};

const SideBar = () => {
  let dat = new Date();
  const { iconHover, sidebarposition, headerposition, sidebarLayout, ChangeIconSidebar } = useContext(ThemeContext);

  const [state, setState] = useReducer(reducer, initialState);
  const [hideOnScroll, setHideOnScroll] = useState(true);
  const [sidebarMenus, setSidebarMenus] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useScrollPosition(({ prevPos, currPos }) => {
    const isShow = currPos.y > prevPos.y;
    if (isShow !== hideOnScroll) setHideOnScroll(isShow);
  }, [hideOnScroll]);

  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  };

  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    }
  };

  useEffect(() => {
    const fetchSidebarMenus = async () => {
      setLoading(true);
      try {
        const response = await getSidebarMenusApi();
        setSidebarMenus(response?.data?.sidebarMenus);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSidebarMenus();
  }, []);



  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div
      onMouseEnter={() => ChangeIconSidebar(true)}
      onMouseLeave={() => ChangeIconSidebar(false)}
      className={`dlabnav ${iconHover} ${sidebarposition.value === "fixed" && sidebarLayout.value === "horizontal" && headerposition.value === "static"
        ? hideOnScroll > 120
          ? "fixed"
          : ""
        : ""
        }`}
    >
      <div className="dlabnav-scroll">
        <ul className="metismenu" id="menu">
          {sidebarMenus?.map((menu, index) => (

            <li
              className={` ${state.active === menu.menu ? "mm-active" : ""
                }`}
              key={menu._id}
            >
              {menu.subMenu && menu.subMenu.length > 0 ? (
                <>
                  <Link
                    to={"#"}
                    className="has-arrow"
                    onClick={() => handleMenuActive(menu.menu)}
                  >
                    <i className="la la-folder"></i> {/* Replace with appropriate icon */}
                    <span className="nav-text">{menu.menu}</span>
                  </Link>
                  <Collapse in={state.active === menu.menu}>
                    <ul className="mm-show">
                      {menu.subMenu.map((subItem, subIndex) => (
                        <li
                          key={subItem._id || subIndex}
                          className={`${state.activeSubmenu === subItem.title ? "mm-active" : ""}`}
                        >
                          <Link to={subItem.to || "#"}>{subItem.menu || "Sub Menu"}</Link>
                        </li>
                      ))}
                    </ul>
                  </Collapse>
                </>
              ) : (
                <Link to={menu.to || "#"}>
                  <i className="la la-folder"></i> {/* Replace with appropriate icon */}
                  <span className="nav-text">{menu.menu}</span>
                </Link>
              )}
            </li>
          ))}
        </ul>

        <div className="copyright">
          <p>Idea2Reality Admin © {dat.getFullYear()} All Rights Reserved</p>
          <p className="fs-12">Made with <span className="heart"
            onClick={(e) => e.target.classList.toggle('heart-blast')}
          ></span> by Idea2Reality.tech</p>
        </div>
      </div>
    </div>


  );
};

export default SideBar;
